import { InventoryEntryRepository } from '@InventoryControl/Entries/Data/Repository/EntryRepository'

export interface DeleteEntry {
    execute(id: string): Promise<void>
    getSource(): string
}

export class DeleteEntryUseCase implements DeleteEntry {
    constructor(private repository: InventoryEntryRepository) {}
    async execute(id: string) {
        return this.repository.delete(id)
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
